import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { DateUtility } from '@jms/model';

@Pipe({
  name: 'toDateTime',
  standalone: true
})
export class ToDateTimePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): DateTime {

    const result = DateUtility.getDateTime(value);

    return result;
  }

}
